"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _format = _interopRequireDefault(require("date-fns/format"));
var _getArabicDayOfWeek = _interopRequireDefault(require("../getArabicDayOfWeek"));
var _getArabicMonthWithLabel = _interopRequireDefault(require("../getArabicMonthWithLabel"));
var _LANGUAGES = _interopRequireDefault(require("../../../constants/lang/LANGUAGES"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * returns the formatted DayMonth on the base of language.
 * @param {Date} date
 * @param {String} language
 * @returns {String}
 */
function getLocaleDayMonth(date, language) {
  var day = (0, _format["default"])(date, 'E');
  var month = (0, _format["default"])(date, 'd MMMM');
  var isArabic = language === _LANGUAGES["default"].AR;
  //  get arabic month name if language is arabic.
  var monthTxt = isArabic ? (0, _getArabicMonthWithLabel["default"])(month) : month;
  // get arabic day of week if language is arabic.
  var dayTxt = isArabic ? (0, _getArabicDayOfWeek["default"])(day) : day;
  var formattedDayMonth = "".concat(dayTxt, ", ").concat(monthTxt);
  return formattedDayMonth;
}
var _default = exports["default"] = getLocaleDayMonth;